import { routeConstants } from "services/keyConstants";

let productBaseUrl = "/product";
const baseUrl = `/${routeConstants.ADVISORY_NOTICE_AND_RECALL}`;
const baseUrlNotice = `${baseUrl}/notice`;
const baseUrlFormat = `${baseUrl}/format`;

// export const CREATER = `${baseUrl}/`;

// export const GET_FORMAT_DATA = `${baseUrlFormat}/`;

// export const GET_RETURNED_GOODS_RECORDS = `${baseUrlFormat}/return-of-goods/`;

// export const DOWNLOAD_DOCUMENT = `${baseUrlFormat}/download`;

// export const CREATE_ADVISORY_NOTICE = `${baseUrlNotice}`;

export const GET_BY_YEAR = `${baseUrlNotice}/year-list`;

// export const GET_PRODUCTS = `${productBaseUrl}/get-all`;

export const GET_CUSTOMER_AND_DISTRIBUTOR = `/customer-related-process-and-distribution-new/order/get-list`;

// export const NOTICE_DOWNLOAD = `${baseUrlNotice}/download`;

const baseMrm = "/monitoring-and-measuring-of-product";

// export const GET_SELECTED_PRODUCT_LIST = `${baseMrm}/get-list`;

// export const FIND_AND_CREATE_RECALL = `${baseUrl}/format/recall-register`;

// export const UPDATE_SPECIFIC = `${baseUrl}/format/specific/`;

// export const GET_COUNT = `${baseUrlNotice}/getcount`;

// export const GET_RECALL_COUNT = `${baseUrlFormat}/get-count`;

// export const GET_CHART_DATA = `${baseUrlNotice}/get-chart`;

// export const GET_RECALL = `${baseUrlFormat}/get-recall`;

// export const GET_REGISTER = `${baseUrlFormat}/get-register`;

export const SAVE_REGISTER = `${baseUrlFormat}/save-register`;

// export const GET_RECALL_RETRUN = `${baseUrlFormat}/recall-returned`;

// export const UPDATE_RECALL_RETRUN = `${baseUrlFormat}/recall-returned`;
